import * as React from 'react';
import { withRouter } from 'react-router-dom';

import Card from 'components/molecules/Card';
import CARD_RENDER_LOCATION from 'containers/molecules/Card/enum-card-render-location';
import { mapDispatchToProps, mapStateToProps } from 'containers/views/PoolCustomWorkoutView';
import { CardTypes } from 'defs/card-types';

export type PoolDetailRendererPropsType = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

class PoolCustomWorkoutView extends React.Component<PoolDetailRendererPropsType> {
	public static displayName = 'Pool(CustomWorkoutView)';

	public componentDidMount() {
		this.props.doLoadAsset('workout/fallback');
	}

	public render() {
		const { programItemRef, weight, userData, previewImage, currentDayNumber, history } = this.props;
		const cardId = programItemRef ? `${programItemRef}` : 'custom-workout-static-id';
		const imageSign = previewImage ? JSON.stringify(previewImage).length : 0;

		return (
			<React.Fragment>
				<Card
					{...({} as any)}
					isCustom
					id={cardId}
					cardRenderLocation={CARD_RENDER_LOCATION.POOL_CUSTOM}
					uiState="detail"
					type={CardTypes.Workout}
					history={history}
					programItemRef={programItemRef}
					previewImage={previewImage}
					preselectedCustomWorkoutPreviewImage={previewImage}
					currentDayNumber={currentDayNumber}
					weight={weight}
					userData={userData}
					signature={`custom-workout-${imageSign}-${programItemRef || ''}${weight || 0}${cardId}`}
					onBackFromDetail={() => {
						this.props.history.goBack();
					}}
				/>
			</React.Fragment>
		);
	}
}

export default withRouter(PoolCustomWorkoutView as any);
